import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { Platform } from "@ionic/angular/common";
import { filter } from "rxjs";
import { environment } from "src/environments/environment.prod";

/**
 * Classe responsavel pelo gerenciamento do GoogleAnalytics
 * @author Starley Cazorla
 */

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {

    currentScreenName: string;

    constructor(private platform: Platform,
        private router: Router
    ) {
        // Get screen name from url
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
            const urlWithoutParams = event.url.replace(/\?.*/, ''); // Remove tudo após o '?' (parâmetros)
            const lastSlashIndex = urlWithoutParams.lastIndexOf('/');
            const url = urlWithoutParams.substring(lastSlashIndex + 1);
            this.currentScreenName = url;
            this.setScreenName(url);
        })

    }

    async startAnalytics() {
        if (!this.platform.is('cordova')) {
            FirebaseAnalytics.initializeFirebase(environment.firebaseConfig)
        }
    }

    /**
     * Platform: Android/iOS
     * Retrieves the app instance id from the service.
     * @param none
     * @returns instanceId - individual instance id value
     * https://firebase.google.com/docs/analytics/user-properties
     */
    getAppInstanceId() {
        FirebaseAnalytics.getAppInstanceId();
    }

    /**
     * Registro de logs e eventos
     * @param module
     * @param view
     */
    logEvent(module: string, view: string) {
        FirebaseAnalytics.logEvent({
            name: module,
            params: {
                method: view,
                screen: this.currentScreenName
            }
        }).catch((error) => {
            console.log("🚀 ~ file: google-analytics.service.ts:46 ~ GoogleAnalyticsService ~ logEvent ~ error:", error)
        });
    }

    setScreenName(urlName: string) {
        FirebaseAnalytics.setScreenName({ screenName: urlName }).catch((error) => {
            console.log("🚀 ~ GoogleAnalyticsService ~ setScreenName ~ error:", error);
        })
    }

}
